import {
    FETCH_TEAMS,
    FETCH_TEAMS_FAIL,
    FETCH_TEAMS_SUCCESS
} from './actionTypes';
import * as _ from 'lodash';

const initialState = {
    data: [],
    error: null,
    loading: false,
    loaded: false
};

export function teamsListReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_TEAMS:
            return {
                ...state,
                loading: true
            };
        case FETCH_TEAMS_SUCCESS:
            return {
                ...state,
                data: _.sortBy(action.payload, t => t.id),
                loaded: true,
                loading: false
            };
        case FETCH_TEAMS_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        default:
            return state;
    }
}
